/**
 * @param {Event} event
 */
export default function preventDefault(event) {
    event?.preventDefault?.();
}